export const meta = {
    keyExpr: 'kod_spr_smet_zatr',
    sort: {
        type: 'desc',
        field: 'smet_name',
    },
    columns: [
        {
            name: 'kod_spr_smet_zatr',
            caption: 'kod_spr_smet_zatr',
            dataField: 'kod_spr_smet_zatr',
            allowEditing: true,
            width: 250,
            index: 1,
            visible: false,
        },
        {
            name: 'smet_code',
            caption: 'Статья затрат',
            dataField: 'smet_code',
            allowEditing: true,
            index: 2,
            visible: true,
        },
        {
            name: 'smet_name',
            caption: 'Наименование статьи затрат',
            dataField: 'smet_name',
            allowEditing: true,
            index: 3,
            visible: true,
        },
        {
            name: 'kod_spr_smet_calc',
            caption: 'Статья калькуляции',
            dataField: 'kod_spr_smet_calc',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 's_name',
            },
            component: {
                name: 'sprsmetcalclookup-view',
                id: 'kod_spr_smet_calc',
                text: 'smet_calc_name',
            },
            index: 4,
            visible: true,
        },
        {
            name: 'period_s',
            caption: 'Срок действия "с"',
            dataField: 'period_s',
            allowEditing: true,
            width: 250,
            index: 5,
            visible: true,
        },
        {
            name: 'period_po',
            caption: 'Срок действия "по"',
            dataField: 'period_po',
            allowEditing: true,
            index: 6,
            visible: true,
        },
        {
            name: 'storn',
            caption: 'Сторнировать в следующем периоде',
            dataField: 'storn',
            allowEditing: true,
            dataType: 'boolean',
            width: 250,
            index: 7,
            visible: true,
        },
    ],
    api: {
        select: 'mped./mped/vb-spr-smet-zatr-calc-select/get',
        save: 'mped./mped/vb-spr-smet-zatr-calc-save/set',
    },
    viewId: 'sprsmetzatrcalc-view',
};
